<div class="circle" (click)="selectIcon()" [ngClass]="setClasses()"
     [style.background-color]="icon.backgroundColor"
     [style.border-color]="icon.borderColor">
  <i class="{{'fa ' + icon.code}}" aria-hidden="true" [style.color]="icon.color"></i>
</div>
